// FILE: src/pages/Home.jsx
import './home.css';
import './interactive.css';
// import Slider from "react-slick";


export default function Home() {
  return (
    
    <div className="home-container">
      {/* <section className="home-slider">
  <Slider
    dots={true}
    infinite={true}
    speed={500}
    slidesToShow={1}
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={3000}
  >
    {[...Array(3)].map((_, index) => (
      <div key={index}>
        <img
          src={`../public/slide${index + 1}.jpg`}
          alt={`slide ${index + 1}`}
          className="slider-image"
        />
      </div>
    ))}
  </Slider>
</section>

      <h1>Join Merchant Navy</h1>
      <p className="breadcrumb">Home / Join Merchant Navy</p>

      <section className='hover-fill'>
        <h2>How to join Merchant Navy</h2>
        <p>
          Joining the Merchant Navy is an exciting and rewarding career choice that offers
          opportunities for personal and professional growth. If you are considering a career at sea,
          there are several paths you can take to join the Merchant Navy.
        </p>
        <ul>
          <li>Research Different Roles and Identify Preferred Role</li>
          <li>Obtain Necessary Qualifications</li>
          <li>Medical Fitness</li>
          <li>Obtain Certifications</li>
          <li>Stay Informed</li>
          <li>Network for Guidance</li>
        </ul>
      </section> */}
      {/* <div className='carousel-wrapper position-relative'>
        <img src='/logo.png' alt='logo' className='carousel-logo'/>
        <span className='logo-caption'>Ocean Cruise</span>
      </div> */}
      <div id="carouselExampleAutoplaying" class="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src= "/images/slide0.jpg" className="d-block  w-100" alt="slide1" />
    </div>
    <div className="carousel-item">
      <img src= "/images/slide1.jpg" className="d-block  w-100" alt="slide2"/>
    </div>
    <div className="carousel-item">
      <img src= "/images/slide2.jpg" className="d-block  w-100" alt="slide2"/>
    </div>
    <div className="carousel-item">
      <img src= "/images/slide3.jpg" className="d-block  w-100" alt="slide3"/>
    </div>
    <div className="carousel-item">
      <img src= "/images/slide4.jpg" className="d-block  w-100" alt="slide2"/>
    </div>
    <div className="carousel-item">
      <img src= "/images/slide5.jpg" className="d-block  w-100" alt="slide2"/>
    </div>
    <div className="carousel-item">
      <img src= "/images/slide6.jpg" className="d-block  w-100" alt="slide2"/>
    </div>
    <div className="carousel-item">
      <img src= "/images/slide7.jpg" className="d-block  w-100" alt="slide2"/>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
<section className="container my-5" id="about-us">
  <h2 className="text-center mb-4">ABOUT | US</h2>
  <div className="p-3 border rounded hover-fill">
  <div className="row align-items-center">
    
    <div className="col-md-6">
      <p><strong>Ocean Cruise Career Service </strong>is a leading maritime training and recruitment company dedicated to shaping future seafarers and hospitality professionals for global opportunities. Established with a vision to bridge the gap between passionate individuals and world-class marine careers, we provide a comprehensive platform for learning, development, and placement in the merchant navy, cruise liners, and offshore sectors.</p>
      <ul className="list-unstyled">
        <li>✔️ Crew Manning & Deployment for Cargo, Cruise, Oil & Gas</li>
        <li>✔️ STCW & DG-Approved Maritime Training Programs</li>
        <li>✔️ CDC/SID and  VISA process and procedures.</li>
      </ul>
    </div>
    <div className="col-md-6">
      <img src="/images/about.jpg" alt="About Ship" className="img-fluid rounded shadow" />
    </div>
  </div>
  </div>
</section>
<section className="container my-5" id="why-us">
  <h2 className="text-center mb-4">WHY US?</h2>
  <div className="row text-center">
    <div className="col-md-3">
      <div className="p-3 border rounded hover-fill">
        <img src="\images\recruitmenticon.png" alt="Icon 1" style={{ height: '60px' }} />
        <h5 className="mt-3">Recruitment Specialist</h5>
        <p className="small">We use industry insight and tech to find the best crew for ships and hotels.</p>
      </div>
    </div>
    <div className="col-md-3">
      <div className="p-3 border rounded hover-fill">
        <img src="\images\technologyinsights.png" alt="Icon 2" style={{ height: '60px' }} />
        <h5 className="mt-3">Technology Insights</h5>
        <p className="small">We use intuitive tools and analysis to enhance performance and transparency.</p>
      </div>
    </div>
    <div className="col-md-3">
      <div className="p-3 border rounded hover-fill">
        <img src="\images\customtraining.png" alt="Icon 3" style={{ height: '60px' }} />
        <h5 className="mt-3">Custom Training</h5>
        <p className="small">We tailor training portfolios based on client needs and STCW standards.</p>
      </div>
    </div>
    <div className="col-md-3">
      <div className="p-3 border rounded hover-fill">
        <img src="\images\p2model.png" alt="Icon 4" style={{ height: '60px' }} />
        <h5 className="mt-3">P2 Processing Model</h5>
        <p className="small">Fast, reliable processing through partnerships and stakeholder networks.</p>
      </div>
    </div>
  </div>
</section>
    </div>
  );
}


